import { checkout } from 'core';
import HeaderWidget from './widgets/HeaderCheckout';
import PaymentWidget from './widgets/Payment';
import SummaryWidget from './widgets/Summary';

const CheckoutContainer = () => {
  const { step } = checkout.hooks.useCheckout();
  return (
    <>
      <HeaderWidget />
      {step === `payment` ? <PaymentWidget /> : <SummaryWidget />}
    </>
  );
};

export default CheckoutContainer;
